// extracted by mini-css-extract-plugin
export default {"containerBotoes":"EditarPessoa_containerBotoes__yorNV","container":"EditarPessoa_container__MmZzh","card":"EditarPessoa_card__vrwmv","inputCep":"EditarPessoa_inputCep__1Xwy0"};